import inputData from './inputData/kyc-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'kyc-form',
  title: 'KYC Form',
  description: 'Verify client information accurately and meet compliance standards while minimizing onboarding risk.',
  image: '/images/templates/kyc-form.png',
  tags: ['customer-success', 'human-resources'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

